import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'formatPriceSignal'
})
export class FormatPriceSignalPipe implements PipeTransform {
	transform(value: any, signal = true): any {
		if (signal) {
			value = '+ ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		} else {
			value = '- ' + Number(value).toLocaleString('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
		}

		return value;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/format-price-signal.pipe.ts